module.exports = __webpack_public_path__ + "img/f50ace2.png";